t = require('views/internal/teacup-with-helpers')('atMention')

module.exports = ->
  t.span { class: 'atMention' + t.mustacheBlock('isMe', (-> ' me')), title: t.mustacheVar('fullName') }, ->
    t.text t.mustacheVar('atMention')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/atMention.coffee